import React, { useEffect, useMemo, useState } from "react";
import { MaterialReactTable } from "material-react-table";
import { MRT_Localization_ES } from "material-react-table/locales/es"; //Tabla en español
import Navbar from "../../Navbar";
import {
  Container,
  Box,
  Typography,
  ListItemIcon,
  MenuItem,
  Alert,
  Button,
} from "@mui/material";
import { createTheme, ThemeProvider, useTheme } from "@mui/material";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import EditNoteIcon from "@mui/icons-material/EditNote";
import { getData } from "../../../services/library";
import moment from "moment";
import { UrlApi } from "../../../services/apirest";
import ModalEntrevistaFechaHora from "./ModalEntrevistaFechaHora";
import ModalEliminarEntrevistasFuturas from "./ModalEliminarEntrevistasFuturas";
import { useNavigate } from "react-router-dom";
import { simpleFetch } from "./useFectch";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { logEventos } from "../../../services/services"; 

const ProximasEntrevistas = () => {
  const [proximasEntrevistas, setProximasEntrevistas] = useState([]);

  const [nuevaFechaDeEntrevista, setNuevaFechaDeEntrevista] = useState(null);
  const [abrirModalEdicion, setAbrirModalEdicion] = useState(false);
  const [abrirModalEliminacion, setAbrirModalEliminacion] = useState(false);
  const [idEntrevista, setIdEntrevista] = useState(-1);

  const [mostrarAlerta, setMostrarAlerta] = useState(false);
  const [message, setMessage] = useState("");
  const [severity, setSeverity] = useState("");

  const mostrarAlertaTemporal = (mensaje, severidad) => {
    setMostrarAlerta(true);
    setMessage(mensaje);
    setSeverity(severidad);

    setTimeout(() => {
      setMostrarAlerta(false);
    }, 5000);
  };

  const handleOpenDeleteModal = (id) => {
    setIdEntrevista(id);
    setAbrirModalEliminacion(true);
  };

  const handleOpenUpdateModal = (id, fecha) => {
    setIdEntrevista(id);
    setNuevaFechaDeEntrevista(moment(fecha).format("YYYY-MM-DDTHH:mm"));
    setAbrirModalEdicion(true);
  };

  const navigate = useNavigate();

  const deleteEntrevista = async (e) => {
        logEventos(
      "deleteEntrevista",
      "agenda entrevista",
      "Eliminar entrevista",
      localStorage.getItem("user")
    );
    e.preventDefault();

    const response = await fetch(
      `${UrlApi}/SP_proximas_entrevistas/${idEntrevista}`,
      {
        headers: {
          "Content-Type": "application/json",
        },
        method: "DELETE",
      }
    );
    if (response.ok)
      mostrarAlertaTemporal("La entrevista se elimino con exito", "success");
    else mostrarAlertaTemporal("Fallo al eliminar la entrevista", "error");
  };
//log puesto por guille a tarea logs de eventos
  const actualizarEntrevista = async (e) => {
        logEventos(
      "actualizarEntrevista",
      "agenda entrevista",
      " modificar entrevista",
      localStorage.getItem("user")
    );
    e.preventDefault();

    const response = await fetch(
      `${UrlApi}/SP_proximas_entrevistas/${idEntrevista}`,
      {
        headers: {
          "Content-Type": "application/json",
        },
        method: "PUT",
        body: JSON.stringify({ fecha_hora: nuevaFechaDeEntrevista }),
      }
    );
    if (response.ok)
      mostrarAlertaTemporal("La entrevista se modifico con exito", "success");
    else mostrarAlertaTemporal("Fallo al modificar la entrevista", "error");
  };

  const obtenerEntrevistas = () => {
    getData("/SP_proximas_entrevistas", (data) => {
      setProximasEntrevistas(Array.isArray(data) ? data : []);
    });
  };
  useEffect(() => {
    obtenerEntrevistas();
  }, []);

  const initialState = {
    density: "compact",
    showGlobalFilter: true,
    pagination: { pageIndex: 0, pageSize: 10 },
  };

  const muiSearchTextFieldProps = {
    placeholder: "Buscar..",
    sx: { minWidth: "18rem", backgroundColor: "#ffffff" },
    variant: "outlined",
    color: "primary",
    size: "small",
  };

  const tableHeadCellProps = {
    align: "left",
    sx: {
      fontSize: 16,
      color: "white",
      fontWeight: "normal",
      backgroundColor: "#2471A3",
      borderColor: "black",
    },
  };

  const columns = useMemo(
    () => [
      { header: "ID", accessorKey: "id", size: 25 },
      {
        accessorKey: "fecha_hora",
        header: "Fecha de la entrevista",
        size: 100,
        Cell: ({ row }) =>
          `${moment(row.original.fecha_hora).format("DD/MM/YYYY HH:mm")}`,
      },
      {
        accessorKey: "nombre",
        header: "Nombre y apellido",
        size: 100,
        Cell: ({ row }) => `${row.original.nombre} ${row.original.apellido}`,
      },
      { header: "Puesto", accessorKey: "puesto", size: 80 },
      { header: "Telefono", accessorKey: "tel_contacto", size: 80 },
    ],
    []
  );

  const globalTheme = useTheme();
  const tableTheme = useMemo(
    () =>
      createTheme({
        palette: {
          mode: globalTheme.palette.mode,
          primary: globalTheme.palette.primary,
          info: {
            main: "rgb(255,122,0)",
          },
          background: {
            default:
              globalTheme.palette.mode === "light"
                ? "rgb(234, 239, 241)"
                : "#000",
          },
        },
        typography: {
          button: {
            textTransform: "none",
            fontSize: "1rem",
          },
        },
        components: {
          MuiTooltip: {
            styleOverrides: {
              tooltip: {
                fontSize: "0.8rem",
              },
            },
          },
        },
      }),
    [globalTheme]
  );

    useEffect(() => {
    logEventos(
      "acceso al menu agenda entrevista",
      "Próximas entrevistas",
      "Lista entrevistas",
      localStorage.getItem("user")
    );
  }, []);
  return (
    <>
      {mostrarAlerta && (
        <Alert
          severity={severity}
          sx={{
            zIndex: 1300,
            position: "fixed",
            top: "20px",
            right: "20px",
            width: "auto",
            borderRadius: "8px",
            backgroundColor: "#d8e6d3",
          }}
        >
          {message}
        </Alert>
      )}
      {abrirModalEdicion && (
        <ModalEntrevistaFechaHora
          isEditMode={true}
          open={abrirModalEdicion}
          onClose={() => setAbrirModalEdicion(false)}
          handleFunction={actualizarEntrevista}
          setDate={setNuevaFechaDeEntrevista}
          date={nuevaFechaDeEntrevista}
          obtenerEntrevistas={obtenerEntrevistas}
        />
      )}
      {abrirModalEliminacion && (
        <ModalEliminarEntrevistasFuturas
          open={abrirModalEliminacion}
          onClose={() => setAbrirModalEliminacion(false)}
          handleFunction={deleteEntrevista}
          obtenerEntrevistas={obtenerEntrevistas}
        />
      )}
      <Navbar />
      <Container maxWidth="xl" mt={1}>
        {proximasEntrevistas ? (
          <Box mt={2} mb={4}>
            <ThemeProvider theme={tableTheme}>
              <MaterialReactTable
                enableToolbarInternalActions={true}
                enableGrouping
                layoutMode="grid"
                muiTableHeadCellProps={tableHeadCellProps}
                muiTableBodyCellProps={({ row }) => ({
                  align: "left",
                  sx: {
                    color: "black",
                    borderColor: "black",
                    backgroundColor: "#fff",
                  },
                })}
                enableColumnActions={true}
                enableColumnFilters={false}
                enableHiding={false}
                enableDensityToggle={false}
                localization={MRT_Localization_ES}
                enableColumnDragging={false}
                initialState={initialState}
                // renderDetailPanel={({ row }) => (
                //   aca va el renderizado desplegable
                // )}
                muiSearchTextFieldProps={muiSearchTextFieldProps}
                columns={columns}
                data={proximasEntrevistas}
                enableStickyFooter
                enableRowActions
                positionActionsColumn="last"
                renderTopToolbarCustomActions={() => (
                  <Box display="flex" alignItems="center" gap={3}>
                    <Button
                      variant="contained"
                      sx={{
                        borderRadius: "50%",
                        backgroundColor: "#368dff",
                        width: 48,
                        height: 48,
                        minWidth: 0,
                        padding: 0,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        "&:hover": {
                          backgroundColor: "#006eff",
                        },
                      }}
                      onClick={() => navigate("/SP_solicitudes")}
                    >
                      <ArrowBackIcon />
                    </Button>
                    <Typography
                      variant="h6"
                      sx={{
                        fontSize: 26,
                        textAlign: "center",
                        flexGrow: 1,
                      }}
                    >
                      Próximas entrevistas
                    </Typography>
                  </Box>
                )}
                renderRowActionMenuItems={({ closeMenu, row }) => [
                  <MenuItem
                    key="edit"
                    onClick={() => {
                      handleOpenUpdateModal(
                        row.original.id,
                        row.original.fecha_hora
                      );
                      closeMenu();
                    }}
                  >
                    <ListItemIcon>
                      <EditNoteIcon sx={{ color: "#478eff" }} />
                    </ListItemIcon>
                    Editar
                  </MenuItem>,
                  <MenuItem
                    key="delete"
                    onClick={() => {
                      handleOpenDeleteModal(row.original.id);
                      closeMenu();
                    }}
                  >
                    <ListItemIcon>
                      <HighlightOffIcon color="error" />
                    </ListItemIcon>
                    Eliminar
                  </MenuItem>,
                ]}
              />
            </ThemeProvider>
          </Box>
        ) : null}
      </Container>
    </>
  );
};

export default ProximasEntrevistas;
